import { render, staticRenderFns } from "./RemoveCompanyRating.vue?vue&type=template&id=626d1958"
import script from "./RemoveCompanyRating.vue?vue&type=script&lang=js"
export * from "./RemoveCompanyRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports